module.exports = __webpack_public_path__ + "assets/img/11-1.31b61f89.png";